import { SVGProps } from 'react'

const Base = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 32C19.1645 32 22.2579 31.0616 24.8891 29.3035C27.5203 27.5454 29.5711 25.0466 30.7821 22.1229C31.9931 19.1993 32.3099 15.9823 31.6926 12.8786C31.0752 9.77486 29.5513 6.92394 27.3137 4.6863C25.0761 2.44866 22.2251 0.924806 19.1214 0.307443C16.0177 -0.309921 12.8007 0.00693265 9.87706 1.21793C6.95345 2.42894 4.45459 4.4797 2.69649 7.11088C0.938384 9.74207 0 12.8355 0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C7.68687 30.3143 11.7565 32 16 32Z"
      fill="#0052FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9624 27.2676C22.1853 27.2676 27.23 22.223 27.23 16C27.23 9.7771 22.1853 4.73242 15.9624 4.73242C10.0588 4.73242 5.21562 9.27262 4.73409 15.0518H21.4544V16.9281H4.73242C5.20435 22.7169 10.0519 27.2676 15.9624 27.2676Z"
      fill="white"
    />
  </svg>
)
export default Base
